import AppRoutes from './router/AppRoutes';

//_____MUI THEME_____
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
//____Toastify_____
import { Bounce, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useGlobalState } from './context/GlobalState';

//_____I18N_____
import './i18n/i18n';

function App() {
  const globalState = useGlobalState();

  return (
    <ThemeProvider theme={globalState.muiTheme}>
      <CssBaseline />
      <AppRoutes />
      <ToastContainer
        position='top-center'
        autoClose={2000}
        hideProgressBar
        closeOnClick
        pauseOnHover={true}
        transition={Bounce}
        theme={'colored'}
      />
    </ThemeProvider>
  );
}
export default App;
